import * as sections from "components/Homeowner/CaseForms/ComparableGrid/Sections/Sections";
import { get } from "lodash";

export const mapBBTMValuePostAdjustment = (o, item) => {
  o.dateOfSaleTime.summaryAdjustmentDesc = item[sections.SALE_DATE_BBT]["right"].value;
  o.location.summaryAdjustmentDesc = item[sections.LOCATION]["right"].value;
  o.site.summaryAdjustmentDesc = item[sections.SITE_BBT]["right"].value;
  o.quality.summaryAdjustmentDesc = item[sections.QUALITY_BBT]["right"].value;
  o.actualAge.summaryAdjustmentDesc = item[sections.ACTUAL_AGE_BBT]["right"].value;
  o.condition.summaryAdjustmentDesc = item[sections.CONDITION_BBT]["right"].value;
  o.aboveGradeRooms.summaryAdjustmentDesc = item[sections.ABOVE_GRADE_ROOM_COUNT_BBT]["right"].value;
  o.grossLivingArea.summaryAdjustmentDesc = item[sections.GLA_BBT]["right"].value;
  o.belowGrade.summaryAdjustmentDesc = item[sections.BASEMENT_FINISHED_BBT]["right"].value;
  o.garageCarport.summaryAdjustmentDesc = item[sections.GARAGE_CARPORT_BBT]["right"].value;
  o.other.summaryAdjustmentDesc = item[sections.OTHER_BBT]["right"].value;
  o.location.locationType1OtherAdjustmentAmount = item[sections.LOCATION_TYPE_1_OTHER]["right"].value;
  o.location.locationType2OtherAdjustmentAmount = item[sections.LOCATION_TYPE_2_OTHER]["right"].value;
};

export const mapBBTMValuePostDesc = (o, item, dir) => {
  o.addressLine1 = item[sections.ADDRESS][dir].value;
  o.geocodeLatitude = item[sections.LATITUDE][dir].value;
  o.geocodeLongitude = item[sections.LONGITUDE][dir].value;
  o.addressLine2 = item[sections.ADDRESS_2][dir].value;
  o.addressCity = item[sections.CITY][dir].value;
  o.addressState = item[sections.STATE][dir].value;
  o.addressPostalCode = item[sections.ZIP][dir].value;
  o.salePrice = item[sections.SALE_PRICE][dir].value;
  o.salePricePerGrossLivingArea = item[sections.SALE_PRICE_GLA][dir].value;
  o.location.summary = item[sections.LOCATION][dir].value;
  o.location.locationRating = item[sections.LOCATION_RATING][dir].value;
  o.location.locationType = item[sections.LOCATION_TYPE][dir].value;
  o.location.locationType2 = item[sections.LOCATION_TYPE_2][dir].value;
  o.site.summary = item[sections.SITE_BBT][dir].value;
  o.site.landAreaSquareFeet = Number(item[sections.SQUARE_FEET][dir].value).toFixed(0);
  o.site.landAreaAcres = Number(item[sections.ACRES][dir].value).toFixed(2);
  o.condition.conditionRating = item[sections.CONDITION_BBT][dir].value;
  o.grossLivingArea.grossLivingArea = item[sections.GLA_BBT][dir].value;
  o.belowGrade.summary = item[sections.BASEMENT_FINISHED_BBT][dir].value;
  o.belowGrade.totalSquareFeet = item[sections.BELOW_GRADE_TOT_SF_BBT][dir].value;
  o.belowGrade.finishedSquareFeet = item[sections.BELOW_GRADE_FIN_SF_BBT][dir].value;
  o.belowGrade.basementExitType = item[sections.BASEMENT_EXIT_TYPE_BBT][dir].value;
  o.garageCarport.summary = item[sections.GARAGE_CARPORT_BBT][dir].value;
  o.garageCarport.drivewayType = item[sections.DRIVEWAY_BBT][dir].value;
  o.garageCarport.drivewayCarCapacity = item[sections.NUM_OF_CARS_BBT][dir].value;
  o.garageCarport.carStorageType1 = item[sections.CAR_STORAGE_1_BBT][dir].value;
  o.garageCarport.carStorageAttachmentType1 = item[sections.ATTACHMENT_TYPE_1_BBT][dir].value;
  o.garageCarport.carStorageCarCapacity1 = item[sections.NUM_OF_CARS_1_BBT][dir].value;
  o.garageCarport.carStorageType2 = item[sections.CAR_STORAGE_2_BBT][dir].value;
  o.garageCarport.carStorageAttachmentType2 = item[sections.ATTACHMENT_TYPE_2_BBT][dir].value;
  o.garageCarport.carStorageCarCapacity2 = item[sections.NUM_OF_CARS_2_BBT][dir].value;
  o.quality.qualityRating = item[sections.QUALITY_BBT][dir].value;
  o.dateOfSaleTime.saleDate = item[sections.SALE_DATE_BBT][dir].value;
  o.aboveGradeRooms.totalRoomCount = item[sections.TOTAL_BBT][dir].value;
  o.aboveGradeRooms.bedroomCount = item[sections.BEDROOMS_BBT][dir].value;
  o.aboveGradeRooms.fullBathroomCount = item[sections.BATHROOMS_BBT][dir].value;
  o.aboveGradeRooms.halfBathroomCount = item[sections.HALF_BATHROOMS_BBT][dir].value;
  o.proximityToSubjectMiles = get(item[sections.PROXIMITY_TO_SUBJECT][dir], ["value", "postValue"]);
  o.dataSources = item[sections.DATA_SOURCES_1004P][dir].value;
  o.actualAge.ageYears = item[sections.ACTUAL_AGE_BBT][dir].value;
  o.other.otherType = item[sections.OTHER_BBT][dir].value;
  o.comparisonToSubject = item[sections.COMPARISON_TO_SUBJECT][dir].value;
  o.adjustmentComments = item[sections.COMMENTS][dir].value;
  o.comparableType = item[sections.COMPARABLE_TYPE][dir].value;
  o.location.locationType1Other = item[sections.LOCATION_TYPE_1_OTHER][dir].value;
  o.location.locationType2Other = item[sections.LOCATION_TYPE_2_OTHER][dir].value;
};
